try {
    const p = process as any;
    p.__check_passed = true;
} catch {
    globalThis.process = {} as any;
}
const proc = typeof process?.env !== 'undefined' ? process?.env : undefined;

export const getEnvVar = (variableName: string): string => {
    const prefixes = ['EXPO_PUBLIC_', 'REACT_APP_'];

    for (const prefix of prefixes) {
        const value = proc?.[`${prefix}${variableName}`];
        if (value !== undefined) {
            return value;
        }
    }

    const metaEnv = (import.meta as any).env;

    if (typeof import.meta !== 'undefined' && metaEnv) {
        const viteValue = metaEnv[`VITE_${variableName}`];
        if (viteValue !== undefined) {
            return viteValue;
        }
    }

    return '';
};
